import { useParams } from 'react-router-dom';
import ArticleLayout from '@/components/feature/ArticleLayout';

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();

  if (!slug) return null;

  return <ArticleLayout slug={slug} />;
}